import {
  MutationCreateSoftAmendmentArgs,
  CreateSoftAmendmentMutation,
  CreateSoftAmendmentDocument,
  MutationAcceptAmendmentArgs,
  AcceptAmendmentMutation,
  AcceptAmendmentDocument,
  AmendmentQueryVariables,
  AmendmentQuery,
  AmendmentDocument,
  MutationCreateCancellationArgs,
  CreateCancellationMutation,
  CreateCancellationDocument,
  GetCancellationQueryVariables,
  GetCancellationQuery,
  GetCancellationDocument,
  MutationAcceptCancellationArgs,
  AcceptCancellationMutation,
  AcceptCancellationDocument,
  MutationCreateDateAmendmentArgs,
  CreateDateAmendmentMutation,
  CreateDateAmendmentDocument,
  AvailabilityCalendarQueryVariables,
  AvailabilityCalendarQuery,
  AvailabilityCalendarDocument,
} from './generated';

import { createQuery, createMutation } from './helpers';

// Soft Amendment

export const createSoftAmendment = createMutation<MutationCreateSoftAmendmentArgs, CreateSoftAmendmentMutation>(
  CreateSoftAmendmentDocument,
);

// Amendment

export const createDateAmendment = createMutation<MutationCreateDateAmendmentArgs, CreateDateAmendmentMutation>(
  CreateDateAmendmentDocument,
);

export const acceptAmendment = createMutation<MutationAcceptAmendmentArgs, AcceptAmendmentMutation>(AcceptAmendmentDocument);

export const getAmendment = createQuery<AmendmentQueryVariables, AmendmentQuery>(AmendmentDocument);

// Cancellation

export const createCancellation = createMutation<MutationCreateCancellationArgs, CreateCancellationMutation>(CreateCancellationDocument);

export const getCancellation = createQuery<GetCancellationQueryVariables, GetCancellationQuery>(GetCancellationDocument);

export const acceptCancellation = createMutation<MutationAcceptCancellationArgs, AcceptCancellationMutation>(AcceptCancellationDocument);

// Availability Calendar

export const getAvailabilityCalendar = createQuery<AvailabilityCalendarQueryVariables, AvailabilityCalendarQuery>(
  AvailabilityCalendarDocument,
);
